import { Outlet } from "react-router-dom";

const DiscountCodesPage = () => <Outlet />;

export default DiscountCodesPage;
